// extracted by mini-css-extract-plugin
export var shake = "_t-0";